// Faixa "leads retidos por volume" — topo do app, para quem pode ver a tela de
// Ingestão. A rajada acontece fora da tela; sem este aviso, o lote ficaria
// esperando sem ninguém saber, e os leads legítimos que caíssem nele junto.
import { useTranslation } from "react-i18next";
import "./i18n.js";
import { ShieldAlert } from "lucide-react";
import { usePendingHold } from "@/hooks/use-ingestion";
import { useAccessSnapshot } from "@/hooks/use-viewer-role";

export function IngestionHoldBanner() {
  const { t } = useTranslation();
  const { permissions } = useAccessSnapshot();
  const podeVer = permissions.has("integrations.ingestion.view");
  const { data: pendente } = usePendingHold(podeVer);
  if (!podeVer || !pendente) return null;

  return (
    <div
      role="status"
      className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1 border-b border-amber-500/30 bg-amber-500/10 px-4 py-2 text-center text-sm text-amber-900 dark:text-amber-200"
    >
      <ShieldAlert aria-hidden="true" className="size-4" />
      <span>{t("ingestion.volumeGuard.banner", { count: pendente.count })}</span>
      <a
        href="/integrations/ingestion?tab=volume"
        className="font-medium underline underline-offset-2"
      >
        {t("ingestion.volumeGuard.bannerAction")}
      </a>
    </div>
  );
}
